import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm">
      <div className="container-custom py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/images/logo.png" 
              alt="PODO FEET Logo" 
              className="h-8 w-auto"
              style={{ filter: 'brightness(0) saturate(100%) invert(64%) sepia(46%) saturate(350%) hue-rotate(58deg) brightness(90%) contrast(87%)' }}
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="font-medium text-gray-700 hover:text-primary transition-colors">
              Startseite
            </Link>
            <Link to="/ueber-uns" className="font-medium text-gray-700 hover:text-primary transition-colors">
              Über mich
            </Link>
            
            <Link to="/preise" className="font-medium text-gray-700 hover:text-primary transition-colors">
              Preise
            </Link>
            <Link to="/kontakt" className="btn btn-primary">
              Kontakt
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2 text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-4 flex flex-col">
            <Link 
              to="/" 
              className="font-medium text-gray-700 hover:text-primary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Startseite
            </Link>
            <Link 
              to="/ueber-uns" 
              className="font-medium text-gray-700 hover:text-primary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Über mich
            </Link>
            
            <Link 
              to="/preise" 
              className="font-medium text-gray-700 hover:text-primary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Preise
            </Link>
            <Link 
              to="/kontakt" 
              className="btn btn-primary w-full text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              Kontakt
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header; 